
graph_ui.web.core.init();